import React from 'react'
import Grid from '../../../common/layout/grid'

/**
 * Lista de opções com checkbox por item + chips das selecionadas.
 * Usado em filtros (prompts) e atribuição (bots do orquestrador).
 */
export default function CheckMultiSelect({
  label,
  options = [],
  value = [],
  onChange,
  cols = '12',
  emptyLabel = 'Nenhuma opção',
  disabled = false,
  bare = false,
}) {
  const selected = (Array.isArray(value) ? value : [])
    .map(Number)
    .filter((id) => Number.isFinite(id))

  const selectedSet = new Set(selected)

  const toggle = (id) => {
    if (disabled) return
    const next = selectedSet.has(id)
      ? selected.filter((x) => x !== id)
      : selected.concat(id)
    onChange(next)
  }

  const remove = (id) => {
    if (disabled) return
    onChange(selected.filter((x) => x !== id))
  }

  const byId = new Map(options.map((opt) => [Number(opt.id), opt]))

  const optionLabel = (opt, id) => {
    if (!opt) return `#${id}`
    const name = opt.name || opt.title || `#${id}`
    const detail = opt.detail
      || (opt.min_result != null && Number.isFinite(Number(opt.min_result))
        ? `≥ ${Number(opt.min_result)}x`
        : null)
    return detail ? `${name} (${detail})` : name
  }

  const body = (
    <div className={bare ? undefined : 'form-group'} style={bare ? undefined : { padding: '0 15px' }}>
      {label ? <label style={{ fontWeight: 600 }}>{label}</label> : null}

      {selected.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
          {selected.map((id) => {
            const opt = byId.get(id)
            const name = optionLabel(opt, id)
            return (
              <span
                key={id}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  padding: '2px 8px',
                  background: '#eceff1',
                  borderRadius: 4,
                  fontSize: 12,
                  lineHeight: '20px',
                }}
              >
                {name}
                {!disabled ? (
                  <button
                    type='button'
                    onClick={() => remove(id)}
                    title='Remover'
                    style={{
                      border: 0,
                      background: 'transparent',
                      cursor: 'pointer',
                      padding: 0,
                      color: '#607d8b',
                      fontWeight: 700,
                      lineHeight: 1,
                    }}
                  >
                    ×
                  </button>
                ) : null}
              </span>
            )
          })}
        </div>
      ) : null}

      <div
        style={{
          maxHeight: 160,
          overflowY: 'auto',
          border: '1px solid #ddd',
          borderRadius: 4,
          padding: '6px 10px',
          background: disabled ? '#f5f5f5' : '#fff',
        }}
      >
        {options.length === 0 ? (
          <div style={{ color: '#9e9e9e', fontSize: 13 }}>{emptyLabel}</div>
        ) : (
          options.map((opt) => {
            const id = Number(opt.id)
            const name = optionLabel(opt, id)
            const checked = selectedSet.has(id)
            return (
              <label
                key={id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  margin: '4px 0',
                  cursor: disabled ? 'default' : 'pointer',
                  fontWeight: 400,
                  fontSize: 13,
                }}
              >
                <input
                  type='checkbox'
                  checked={checked}
                  disabled={disabled}
                  onChange={() => toggle(id)}
                />
                <span>{name}</span>
              </label>
            )
          })
        )}
      </div>
    </div>
  )

  if (bare) return body
  return <Grid cols={cols}>{body}</Grid>
}
